import React, {FC} from 'react';
import {Form, Input, Modal, Switch} from "antd";

type Props = {
    visible: boolean;
    onCreate: (values: any) => void;
    onCancel: () => void;
}

const CreateRoleModal: FC<Props> = ({visible, onCreate, onCancel}) => {

    const [form] = Form.useForm();

    return (
        <Modal
            visible={visible}
            title="Thêm mới chức vụ"
            okText="Thêm mới"
            cancelText="Cancel"
            onCancel={onCancel}
            width={880}
            style={{top: '20px'}}
            onOk={() => {
                form
                    .validateFields()
                    .then(values => {
                        form.resetFields();
                        onCreate(values);
                    })
                    .catch(info => {
                        console.log('Validate Failed:', info);
                    });
            }}
        >
            <Form
                form={form}
                layout="vertical"
                name="form_in_modal"
            >
                <Form.Item
                    name="name"
                    label="Tên chức vụ"
                    rules={[{ required: true, message: 'Trường này là bắt buộc' }]}
                >
                    <Input placeholder="Tên chức vụ"/>
                </Form.Item>
                <Form.Item name="description" label="Mô tả">
                    <Input.TextArea placeholder="Mô tả"/>
                </Form.Item>
                <Form.Item
                    name="authorizationEnable"
                    label="Có thể ủy quyền"
                    valuePropName="checked"
                >
                    <Switch />
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default CreateRoleModal;